import ColorSelector from "@/theme1/components/product/ColorSelector";
import SizeSelector from "@/theme1/components/product/SizeSelector";

export default function ProductVariants({
  product,
  selectedColor,
  selectedSize,
  onColorChange,
  onSizeChange,
}) {
  return (
    <div className="space-y-6">
      <ColorSelector
        colors={product.colors}
        selected={selectedColor}
        onChange={onColorChange}
      />
      <SizeSelector
        sizes={product.sizes}
        selected={selectedSize}
        onChange={onSizeChange}
      />
    </div>
  );
}